import { useEffect, useRef, useState } from 'react';
import { IconMouse } from '../../data/icons';

// 1. Adicionamos a prop 'delay'
export function TextoSelecionado({ children, delay = 0 }) {
  const [visivel, setVisivel] = useState(false);
  const elementoRef = useRef(null);

  useEffect(() => {
    let timerInicio;
    let timerFim;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          
          // 2. Segura o início da animação com base no tempo do delay passado
          timerInicio = setTimeout(() => {
            setVisivel(true); // Adiciona a classe .animar

            // 3. Só conta os 15 segundos para sumir DEPOIS que a animação começou
            timerFim = setTimeout(() => {
              setVisivel(false);
            }, 15000);

          }, delay);

        } else {
          // Se o usuário rolar para longe, cancelamos tudo para não bugar
          setVisivel(false);
          clearTimeout(timerInicio);
          clearTimeout(timerFim);
        }
      },
      { threshold: 0.5 }
    );

    if (elementoRef.current) {
      observer.observe(elementoRef.current);
    }

    return () => {
      observer.disconnect();
      clearTimeout(timerInicio);
      clearTimeout(timerFim);
    };
  }, [delay]); // O React pede para avisar que o hook depende do delay

  return (
    <span 
      ref={elementoRef} 
      className={`os-selection-box ${visivel ? 'animar' : ''}`}
    >
      {children}
      <span className="mouse-icon-wrapper">
        <IconMouse size={15} color='#4facfe' fill='#fff'/>
      </span>
    </span>
  );
}